<template>
    <div class="row">
        <div class="col-12">
            <b-button
                @click="showModal()"
                :disabled="disabled"
            >
                Editar
            </b-button>
            <ModalComponent
                :name="modalName"
                title="Editar dirección fiscal"
                v-on:close="() => cerrar()"
            >  
                <FormDireccionFiscal
                    :direccionFiscal="data"
                    @terminado="editarDireccionFiscal()"
                />
            </ModalComponent>
        </div>
    </div>    
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import FormDireccionFiscal from '@/components/backend/direcciones-fiscales/FormDireccionFiscal';

export default {
    props: {
        direccionFiscal: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalName: 'edit-direccion-fiscal',
            data: Object.assign({}, this.direccionFiscal)
        }
    },
    methods: {
        editarDireccionFiscal() {
            this.data.filters = {};
            this.data.direccion_fiscal_id = this.data.id;

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.direcciones.fiscales.edit'), this.data).then(res => {
                this.$toast.success(res.data.message);
                this.$emit('editado', this.data);
                this.$modal.hide(this.modalName);
            });
        },
        cerrar() {
            this.$modal.hide(this.modalName)
            this.data = Object.assign({}, this.direccionFiscal);
        },
        showModal(){
            this.data = Object.assign({}, this.direccionFiscal);
            this.$modal.show(this.modalName)
        }
    },
    components: {
        ModalComponent, FormDireccionFiscal
    }
}
</script>
